import { jsx as _jsx } from "react/jsx-runtime";
import './Component_EncounterFeed.scss';
import { AwaitModules, ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { EncounterFeedItem } from '../../../../structs/EncounterFeedItem/EncounterFeedItem.js';
import { Component_EncounterFeedItem } from '../Component_EncounterFeedItem/Component_EncounterFeedItem.js';
const modulesToAwait = [
    ...EncounterFeedItem.modulesToAwait,
];
class Component extends ComponentSync {
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.feedItems = nextProps.feedItems;
        state.emptyFeedMessage = nextProps.customEmptyFeedMessage || 'No events to show';
        state.renderContext = nextProps.renderContext;
        return state;
    }
    // ######################## Logic ########################
    // ######################## Render ########################
    render() {
        if (!this.state.feedItems.length)
            return _jsx(LL_V_L, { className: 'c__encounter-feed', children: _jsx("div", { className: 'message', children: this.state.emptyFeedMessage }) });
        return _jsx(LL_V_L, { className: 'c__encounter-feed', children: this.state.feedItems.map(item => _jsx(Component_EncounterFeedItem, { feedItem: item, renderContext: this.state.renderContext, onClick: this.props.onItemClick }, item._id)) });
    }
}
export const Component_EncounterFeed = (p) => _jsx(AwaitModules, { Component: () => _jsx(Component, { ...p }), modules: modulesToAwait });
//# sourceMappingURL=Component_EncounterFeed.js.map